/**
 * created by lei lei
 * 系统日志
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {HEADER_HEIGHT} from "../../constants";
import {Input, Select, Button, DatePicker, Pagination,Modal,Tooltip} from 'antd';
import CustomTable, {TitleIcon} from "../components/customTable/CustomTable";
import *as Actions  from"../../actions/sysLog"
import {Scrollbars} from "react-custom-scrollbars";
import request from "../../base/request";
import {applicationName} from "../../utils";

const {RangePicker} = DatePicker;
const {Search} = Input;
const {Option} = Select;
export default class SysLog extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            logInfo: '',
            userAccount: '',
            type: '0',
            operation: '0',
            startTime: null,
            endTime: null,
            pageNum: 1,
            pageSize: 10,
            dataList:[],
            count:0,
            everyList:[],
            currentPage:1,
            currentPageSize:10,
            currentCount:0,

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getList();
    }
    getList(){
        let startTime = this.state.startTime ? this.state.startTime.format('YYYY-MM-DD') + ' 00:00:00' : null;//YYYY-MM-DD HH:mm:ss
        let endTime = this.state.endTime ? this.state.endTime.format('YYYY-MM-DD') + ' 23:59:59' : null;
        let body={
            pageNum: this.state.pageNum,
            pageSize: this.state.pageSize,
            type: this.state.type,
            operation: this.state.operation,
        };
        if(startTime){
            body.startTime=new Date(startTime).getTime();
            body.endTime=new Date(endTime).getTime();
        }
        if(this.state.logInfo){
            body.logInfo=this.state.logInfo;
        }
        if(this.state.userAccount){
            body.userAccount=this.state.userAccount;
        }
        Actions.getList(body,res=>{
            let data=[];
            let count=0;
            if(res&&res.data){
                data=res.data;//数据
                count=res.count;
            }
            this.setState({
                dataList:data,
                count:count
            })
        })
    }

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT; //浏览器窗口的内部高度-顶部导航的高度(上部分70)
        return (
            <div style={{margin: "20px"}}>
                <div style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    height: height - 40
                }}>
                    <div
                        style={{
                            width: "100%",
                            height: "42px",
                            lineHeight: "42px",
                            padding: "0 15px",
                            borderBottom: "1px solid #f6f6f6",
                            color: "black",
                            borderRadius: "2px 2px 0 0",
                            fontSize: "16px",
                            fontWeight: "bold",
                        }}
                    >
                        系统日志
                    </div>
                    <div style={{padding: 20}}>
                        {this.renderHead()}
                    </div>
                    {this.renderContent()}
                </div>
                {
                    this.renderModal()
                }

            </div>
        )
    }

    renderHead() {
        return (
            <div style={{display: 'flex'}}>
                <div >
                    <Select value={this.state.type} style={{width: 120}} onChange={this.handleChangeType}>
                        <Option value="0">不限类型</Option>
                        <Option value="1">系统日志</Option>
                        <Option value="2">
                            业务日志
                        </Option>
                        <Option value="3">投稿日志</Option>
                    </Select>
                </div>
                <div style={{marginLeft: 20}}>
                    <Select value={this.state.operation} style={{width: 120}} onChange={this.handleChange}>
                        <Option value="0">操作不限</Option>
                        <Option value="1">登录</Option>
                        <Option value="2">
                            登出
                        </Option>
                        <Option value="3">
                            新增
                        </Option>
                        <Option value="4">
                            更新
                        </Option>
                        <Option value="5">删除</Option>
                    </Select>
                </div>
                <div style={{marginLeft: 20}}><Search
                    placeholder="搜索账号"
                    value={this.state.userAccount}
                    onChange={(e) => {
                        this.setState({userAccount: e.target.value})
                    }}
                    onSearch={value => this.onSearch()}
                    style={{width: 200}}
                /></div>
                <div style={{marginLeft: 20}}><Search
                    placeholder="搜索描述"
                    value={this.state.logInfo}
                    onChange={(e) => {
                        this.setState({logInfo: e.target.value})
                    }}
                    onSearch={value => this.onSearch()}
                    style={{width: 200}}
                /></div>
                <div style={{marginLeft: 20}}>
                    <RangePicker  value={[this.state.startTime, this.state.endTime]}
                                  format={"YYYY-MM-DD"}
                                  onChange={(date, dateString) => {
                                      this.state.startTime = date[0];
                                      this.state.endTime = date[1];
                                      this.typeChange();
                                  }} />
                </div>
                <Button style={{marginLeft: 20}} type="primary" onClick={()=>this.typeChange()}>查询</Button>
                <Button style={{marginLeft: 20}} type="primary" onClick={()=>this.revert()}>重置</Button>
                <Button style={{marginLeft: 20}} type="primary" onClick={()=>{this.state.currentPage=1;this.getEveryDay()}} >每日日志</Button>
                <Button style={{marginLeft: 20}} type="primary" onClick={()=>this.exportExcel()}>导出</Button>
            </div>
        )
    }

    renderContent() {
        let titleKeyList =
            [{
                key: 'logType',
                titleName: '日志类型',
                align: 'center',
                ellipsis: true,
                width: 100,
            },
                {
                    key: 'userAccount',
                    titleName: '账号',
                    width: 100,
                    align: 'left',
                },
                {
                    key: 'userName',
                    titleName: '名称',
                    width: '20%',
                }, {
                key: 'ip',
                titleName: 'ip地址',
                width: '20%',
            }, {
                key: 'time',
                titleName: '操作时间',
                width: '20%',
            }, {
                key: 'logInfo',
                titleName: '操作描述',
                width: '20%',
                render:(text)=>{
                    return <Tooltip placement={"top"} title={text}>{text.length>10?`${text.substring(0, 10)}...`:text}</Tooltip>
                }
            }, {
                key: 'operationResult',
                titleName: '操作结果',
                width: '20%',
            }, {
                key: 'logOperation',
                titleName: '操作类型',
                width: '20%',
            },];

        let height=document.body.clientHeight - HEADER_HEIGHT-200; //浏览器窗口的内部高度-顶部导航的高度(上部分70)
        return (
            <div>
                <div style={{height:height}}>
                    <Scrollbars>
                        <CustomTable
                            dataSource={this.state.dataList}
                            titleKeyList={titleKeyList}
                            //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                            pagination={false}
                            onRow={(record, index) => {
                                return {
                                    onClick: event => {
                                        console.log('onclickItem', record, index)
                                    }, // 点击行
                                    onDoubleClick: event => {
                                    },
                                    onContextMenu: event => {
                                    },
                                    onMouseEnter: event => {
                                    }, // 鼠标移入行
                                    onMouseLeave: event => {
                                    },
                                };
                            }}
                            locale={{emptyText: '暂无数据'}}

                        />
                    </Scrollbars>
                </div>
                <div style={{float:'right',marginRight:20}}>
                    <Pagination
                        showQuickJumper
                        // defaultCurrent={2}
                        current={this.state.pageNum}
                        pageSize={this.state.pageSize}
                        total={this.state.count}
                        showTotal={total => `共 ${total} 条`}
                        /*  showSizeChanger*/
                        onChange={(page, pageSize) => this.onPaginationChange(page, pageSize)}
                        onShowSizeChange={(page, pageSize) => {
                            this.onPaginationChange(page, pageSize)
                        }}
                    />
                </div>

            </div>
        )
    }

    renderModal(){
        let titleKeyList =
            [
                {
                    key: 'fileName',
                    titleName: '名称',
                    width: 300,
                    align: 'left',
                },
                {
                key: 'fileUrl',
                titleName: '操作',
                width: '20%',
                    render: (text, record, index) => {
                            return (<div>
                                <Button onClick={()=>{this.download(record)}}>下载</Button>
                            </div>

                        )
                    }
            },];
        return(
            <Modal
                title="每日列表"
                visible={this.state.visible}
                onOk={()=>{}}
                onCancel={()=>{this.setState({visible:false})}}
                footer={null}
            >
               <div style={{height:550}}>
                   <div style={{height:500}}>
                       <Scrollbars>
                           <CustomTable
                               dataSource={this.state.everyList}
                               titleKeyList={titleKeyList}
                               //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                               pagination={false}
                               onRow={(record, index) => {
                                   return {
                                       onClick: event => {
                                           console.log('onclickItem', record, index)
                                       }, // 点击行
                                       onDoubleClick: event => {
                                       },
                                       onContextMenu: event => {
                                       },
                                       onMouseEnter: event => {
                                       }, // 鼠标移入行
                                       onMouseLeave: event => {
                                       },
                                   };
                               }}
                               locale={{emptyText: '暂无数据'}}

                           />
                       </Scrollbars>
                   </div>
                   <div style={{float:'right',marginRight:20}}>
                       <Pagination
                           showQuickJumper
                           // defaultCurrent={2}
                           current={this.state.currentPage}
                           pageSize={this.state.pageSize}
                           total={this.state.currentCount}
                           showTotal={total => `共 ${total} 条`}
                           /*  showSizeChanger*/
                           onChange={(page, pageSize) => this.onModalPaginationChange(page, pageSize)}
                           onShowSizeChange={(page, pageSize) => {
                               this.onModalPaginationChange(page, pageSize)
                           }}
                       />
                   </div>
               </div>
            </Modal>
        )
    }

    onPaginationChange(page, pageSize){
        this.state.pageNum=page;
        this.state.pageSize=pageSize;
        this.typeChange()
    }
    onModalPaginationChange(page, pageSize){
       this.state.currentPage=page;
       this.state.currentPageSize=pageSize;
       this.getEveryDay();
    }

    onChange = (date, dateString) => {
        console.log(date, dateString);
    };
    handleChangeType = (val) => {
        this.state.type = val;
        this.typeChange()
    };
    handleChange = (val) => {
        this.state.operation = val;
        this.typeChange()
    };
    onSearch(){
        this.state.pageNum=1;
        this.typeChange();
    }

    typeChange() {
        this.getList()
    }

    revert(){
        this.setState({logInfo: '',
            userAccount: '',
            type: '0',
            operation: '0',
            startTime: null,
            endTime: null,
            pageNum: 1,
            pageSize: 10,},()=>{
            this.typeChange()
        })

    }

    getEveryDay(){
        let body={
            start:this.state.currentPage,
            size:this.state.currentPageSize
        }
        Actions.getAllLogBackup(body,res=>{
           let everyList=[];
           let count=0;
           if(res&&res.data){
               everyList=res.data;
               count=res.count;
           }
           this.setState({everyList,visible:true,currentCount:count})
        })
    }
    exportExcel(){
        let startTime = this.state.startTime ? this.state.startTime.format('YYYY-MM-DD') + ' 00:00:00' : null;//YYYY-MM-DD HH:mm:ss
        let endTime = this.state.endTime ? this.state.endTime.format('YYYY-MM-DD') + ' 23:59:59' : null;
        let body={
            pageNum: this.state.pageNum,
            pageSize: this.state.pageSize,
            type: this.state.type,
            operation: this.state.operation,
        };
        if(startTime){
            body.startTime=new Date(startTime).getTime();
            body.endTime=new Date(endTime).getTime();
        }
        if(this.state.logInfo){
            body.logInfo=this.state.logInfo;
        }
        if(this.state.userAccount){
            body.userAccount=this.state.userAccount;
        }
        request({url:"/cm-sites-" + applicationName()+'/'+ "log/exportLog",method:"downloadPost",body})
      // window.location.href="/cm-sites-" + applicationName()+'/'+ "log/exportLog?"+formateData(body)
    }

    //下载
    download(record){
        window.open("/cm-sites-" + applicationName()+ record.fileUrl + "?download=1")
        //request({url:"/cm-sites-" + applicationName()+ record.fileUrl + "?download=1",method:"get"})
    }

}